// extracted by mini-css-extract-plugin
export default {"mCard":"yB-z","image":"zB-z","imageNoBackground":"AB-z","imageHasCategory":"BB-z","fullWidth":"CB-z"};